const HOTKEY_ABBREVIATIONS: Record<string, string> = {
  cmd: '⌘',
  command: '⌘',
  meta: '⌘',
  lcmd: 'left ⌘',
  rcmd: 'right ⌘',
  shift: '⇧',
  option: '⌥',
  alt: '⌥',
  ctrl: '⌃',
  control: '⌃',
  enter: '↩',
  return: '↩',
  esc: '⎋',
  escape: '⎋',
  tab: '⇥',
  delete: '⌫',
  backspace: '⌫',
  space: '␣',
  arrowup: '↑',
  arrowdown: '↓',
  arrowleft: '←',
  arrowright: '→',
  up: '↑',
  down: '↓',
  left: '←',
  right: '→',
}

/** A hotkey string like "cmd+shift+k" as the glyphs its chips show: ⌘, ⇧, k. */
export function hotkeyKeys(hotkey: string): Array<string> {
  return hotkey
    .split('+')
    .map((key) => key.trim())
    .filter(Boolean)
    .map((key) => HOTKEY_ABBREVIATIONS[key.toLowerCase()] ?? key)
}
